import { emptyLoan, ILoan } from "@/types/loan.type";
import { createContext } from "react";

type InitialStateType = {
  loan: ILoan;
  saveLoan: (loanData: ILoan) => Promise<{
    ok: boolean;
    data: ILoan;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};

export const initialState: InitialStateType = {
  loan: emptyLoan(),
  saveLoan: () => Promise.reject({
    ok: false,
    data: emptyLoan(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}
export const LoanDashboardContext = createContext(initialState)